import React from "react";
import "./contactCard.scss";

// react icons
import { HiArrowLongRight } from "react-icons/hi2";

const ContactCard = ({ data }) => {
  return (
    <div className="contactCard">
      <div className="contactCard__box">
        <span className="contactCard__title">{data.title}</span>

        <span className="contactCard__link">{data.link}</span>

        <a href={data.href} _target="blank" className="contactCard__btn">
          Write Me
          <HiArrowLongRight className="contactCard__icon" />
        </a>
      </div>
    </div>
  );
};

export default ContactCard;
